/**
 * Cutoff date for countdown alert visibility
 * Users who signed up before this date will see the countdown alert
 * Users who signed up on or after this date will not see the countdown alert
 */
export const COUNTDOWN_ALERT_CUTOFF_DATE_IN_MS = new Date(
  '2025-07-17T00:00:00Z'
).getTime();
